var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-8",
    cx: 250.85,
    cy: 343.56,
    rx: 211.54,
    ry: 110.65,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-8",
    d: "M178.32,362.23,190,369a9.57,9.57,0,0,0,8.66,0l113.2-65.36c2.39-1.38,2.39-3.62,0-5l-11.65-6.73a9.57,9.57,0,0,0-8.66,0l-113.2,65.36C175.93,358.61,175.93,360.85,178.32,362.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-8",
    cx: 392.84,
    cy: 356.43,
    rx: 51.75,
    ry: 28.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-8",
    d: "M73.79,383.84c16.22,7.73,42.52,7.73,58.74,0s16.22-20.26,0-28-42.52-7.73-58.74,0S57.57,376.11,73.79,383.84Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.83,61.63c-.28-2-1.89-2.74-3.83-1.61L198.52,121.49a8.58,8.58,0,0,0-3.87,6.71v235c0,2.27,1.48,3.31,3.38,2.47a8.58,8.58,0,0,1-7.25-.24l-4.44-2.55a8.56,8.56,0,0,1-3.88-6.71V121.18a8.53,8.53,0,0,1,3.88-6.71L292.81,53a8.52,8.52,0,0,1,7.74,0L305,55.54A8.68,8.68,0,0,1,308.83,61.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,60,198.52,121.49a8.58,8.58,0,0,0-3.87,6.71v235c0,2.46,1.74,3.47,3.87,2.23L305,303.92a8.59,8.59,0,0,0,3.87-6.71v-235C308.87,59.79,307.13,58.78,305,60Zm-1.71,215.07c0,2.11-1.48,3.45-3.32,4.51l-96.81,55.89c-1.83,1.06-3.32.21-3.32-1.91V150.64a7.38,7.38,0,0,1,3.32-5.76L300,89c1.84-1.06,3.32-.2,3.32,1.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,365.63a8.58,8.58,0,0,1-7.25-.24l-4.44-2.55a8.58,8.58,0,0,1-3.88-6.71V121.18a8,8,0,0,1,1.14-3.83l12.19,7a8,8,0,0,0-1.14,3.82v235C194.65,365.43,196.13,366.47,198,365.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,95.93c1.43-.83,2.6-.16,2.6,1.5a5.77,5.77,0,0,1-2.6,4.5c-1.43.82-2.6.15-2.6-1.5A5.76,5.76,0,0,1,251.76,95.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,329a3.61,3.61,0,0,1-1.84-.48c-1.32-.76-2-2.32-2-4.39a14.08,14.08,0,0,1,6.36-11c1.79-1,3.51-1.19,4.82-.43s2,2.32,2,4.39a14.05,14.05,0,0,1-6.36,11A6,6,0,0,1,250,329Zm5.46-15.79a5.1,5.1,0,0,0-2.48.77,13,13,0,0,0-5.86,10.15c0,1.7.54,2.95,1.54,3.53s2.35.42,3.82-.43a13,13,0,0,0,5.86-10.16c0-1.7-.54-2.95-1.54-3.52A2.62,2.62,0,0,0,255.41,313.22Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74,111.72l20-11.57c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6l-20,11.57c-1.2.69-2.17.2-2.17-1.09A4.64,4.64,0,0,1,241.74,111.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29,275.09c0,2.11-1.48,3.45-3.32,4.51l-96.81,55.89c-1.83,1.06-3.32.21-3.32-1.91V150.64a7.38,7.38,0,0,1,3.32-5.76L300,89c1.84-1.06,3.32-.2,3.32,1.91Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29,275.09c0,2.11-1.48,3.45-3.32,4.51l-96.81,55.89c-1.83,1.06-3.32.21-3.32-1.91V150.64a7.38,7.38,0,0,1,3.32-5.76L300,89c1.84-1.06,3.32-.2,3.32,1.91Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,89l-96.81,55.88a7.38,7.38,0,0,0-3.32,5.76V163l103.45-59.74V90.91C303.29,88.8,301.81,87.94,300,89Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,320.09v13.49c0,2.12,1.49,3,3.32,1.91L300,279.6c1.84-1.06,3.32-2.4,3.32-4.51V260.37Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,320.3l72.34-41.8c1.67-1,3-.18,3,1.75v0a6.72,6.72,0,0,1-3,5.25l-72.34,41.8c-1.67,1-3,.18-3-1.75v0A6.72,6.72,0,0,1,208.35,320.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.88,272.64v2.13c0,.48.25.81.55.74l3.41-.79c.3-.07.3.1,0,.38l-3.41,3.14a2.12,2.12,0,0,0-.55,1.37v2.13c0,.48.24.59.53.25l8.09-9.46c.28-.34.28-.62,0-.62l-8.09-.13C289.12,271.78,288.88,272.16,288.88,272.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,196.65l-5.14-3a.49.49,0,0,1-.24-.21l-.94-1.65,3-1.76-.09.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,190.31l3.56,6.16a.53.53,0,0,0,1-.09l3.76-10.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,145.69a5.5,5.5,0,0,0-2.49-4.31h0a5.45,5.45,0,0,0-5,0L208.14,164.6a5.52,5.52,0,0,0-2.49,4.31v20.38a5.5,5.5,0,0,0,2.49,4.31h0a5.45,5.45,0,0,0,5,0l40.48-23.38c2.24-1.27,2.26-2.55,2.26-4.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.65,189.29a5.5,5.5,0,0,0,2.49,4.31h0a5.52,5.52,0,0,0,4.54.21c-1.17.45-2.06-.22-2.06-1.64V171.78a5,5,0,0,1,.73-2.45l-5-2.87a5.09,5.09,0,0,0-.73,2.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,145c-.29-1-1.25-1.39-2.4-.73l-40.25,23.22a4.92,4.92,0,0,0-1.75,1.86l-5-2.87a5,5,0,0,1,1.75-1.85l40.25-23.22a5.51,5.51,0,0,1,5,0h0A5.43,5.43,0,0,1,255.76,145Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,176.64,246.06,160c.83-.48,1.5-.26,1.5.49a3,3,0,0,1-1.5,2.23L217.3,179.36c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,217.3,176.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,182.54l20-11.62c.84-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-20,11.62c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,217.3,182.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,170.76l28.76-16.68c.83-.48,1.5-.26,1.5.49a3,3,0,0,1-1.5,2.23L217.3,173.48c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,217.3,170.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.94,198.82l-3.15-1.8a3.35,3.35,0,0,0-3.36.34,9.64,9.64,0,0,0-3.19,3.25,10,10,0,0,0-1.59,5,3.37,3.37,0,0,0,1.4,3.09l3.15,1.81a3.3,3.3,0,0,0,3.46-.29,10.56,10.56,0,0,0,4.78-8.27A3.31,3.31,0,0,0,216.94,198.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,197a3.35,3.35,0,0,0-3.36.34,9.73,9.73,0,0,0-3.19,3.25,10,10,0,0,0-1.59,5,3.35,3.35,0,0,0,1.4,3.09l3.12,1.79a3.45,3.45,0,0,1-1.29-3,10.6,10.6,0,0,1,4.78-8.28,3.48,3.48,0,0,1,3.24-.41Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,200.66c.88-.51,1.59-.1,1.59.91a3.52,3.52,0,0,1-1.59,2.76c-.88.5-1.59.09-1.59-.92A3.48,3.48,0,0,1,213.46,200.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,209.36a8.32,8.32,0,0,0,2.92-3.17v-.13c0-1.67-1.17-2.34-2.61-1.51l-.9.52a5.79,5.79,0,0,0-2.59,4.29,1.55,1.55,0,0,0,.23.21h0A2.77,2.77,0,0,0,213.67,209.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,270.63l-5.14-3a.54.54,0,0,1-.24-.21l-.94-1.65,3-1.77-.09.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,264.29l3.56,6.16a.53.53,0,0,0,1-.09l3.76-10.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85,219.67a5.5,5.5,0,0,0-2.49-4.31h0a5.51,5.51,0,0,0-5,0l-40.25,23.22a5.5,5.5,0,0,0-2.49,4.31v20.38a5.52,5.52,0,0,0,2.49,4.31h0a5.45,5.45,0,0,0,5,0l40.48-23.38c2.24-1.28,2.26-2.56,2.26-4.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.65,263.27a5.52,5.52,0,0,0,2.49,4.31h0a5.52,5.52,0,0,0,4.54.21c-1.17.44-2.06-.22-2.06-1.64V245.75a5.09,5.09,0,0,1,.73-2.45l-5-2.86a5.06,5.06,0,0,0-.73,2.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,219c-.29-1.06-1.25-1.39-2.4-.73l-40.25,23.22a4.85,4.85,0,0,0-1.75,1.86l-5-2.87a5,5,0,0,1,1.75-1.85l40.25-23.23a5.57,5.57,0,0,1,5,0h0A5.45,5.45,0,0,1,255.76,219Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,250.62l28.76-16.69c.83-.48,1.5-.26,1.5.5a3,3,0,0,1-1.5,2.22L217.3,253.33c-.83.49-1.5.27-1.5-.49A3,3,0,0,1,217.3,250.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,256.51l20-11.61c.84-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-20,11.61c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,217.3,256.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,244.74l28.76-16.68c.83-.49,1.5-.27,1.5.49a3,3,0,0,1-1.5,2.23L217.3,247.46c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,217.3,244.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.94,272.8l-3.15-1.8a3.35,3.35,0,0,0-3.36.34,9.64,9.64,0,0,0-3.19,3.25,10,10,0,0,0-1.59,5,3.37,3.37,0,0,0,1.4,3.09l3.15,1.8a3.28,3.28,0,0,0,3.46-.28,10.56,10.56,0,0,0,4.78-8.28A3.3,3.3,0,0,0,216.94,272.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,271a3.35,3.35,0,0,0-3.36.34,9.73,9.73,0,0,0-3.19,3.25,10,10,0,0,0-1.59,5,3.35,3.35,0,0,0,1.4,3.09l3.12,1.78a3.42,3.42,0,0,1-1.29-3,9.87,9.87,0,0,1,1.59-5,9.68,9.68,0,0,1,3.19-3.26,3.48,3.48,0,0,1,3.24-.41Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,274.63c.88-.5,1.59-.09,1.59.92a3.5,3.5,0,0,1-1.59,2.75c-.88.51-1.59.1-1.59-.91A3.52,3.52,0,0,1,213.46,274.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,283.34a8.35,8.35,0,0,0,2.92-3.18V280c0-1.67-1.17-2.34-2.61-1.51l-.9.52a5.77,5.77,0,0,0-2.59,4.28,1.2,1.2,0,0,0,.23.22h0A2.77,2.77,0,0,0,213.67,283.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.55,200.73l-5.14-3a.49.49,0,0,1-.24-.21l-.95-1.65,3.06-1.76-.1.27Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.55,200.73l-5.14-3a.49.49,0,0,1-.24-.21l-.95-1.65,3.06-1.76-.1.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M278.81,194.39l3.56,6.16a.53.53,0,0,0,1-.09l3.76-10.85Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.29,160.05a5.51,5.51,0,0,0-2.48-4.31h0a5.51,5.51,0,0,0-5,0L250.59,179a5.47,5.47,0,0,0-2.49,4.3v20.39a5.47,5.47,0,0,0,2.49,4.3h0a5.51,5.51,0,0,0,5,0L296,184.57c2.23-1.27,2.25-2.55,2.25-4.14Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,190l28.75-16.68c.83-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-28.75,16.68c-.83.48-1.51.26-1.51-.49A3,3,0,0,1,261.48,190Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19,190.77l20-11.62c.83-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-20,11.62c-.83.48-1.51.26-1.51-.49A3,3,0,0,1,270.19,190.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,184.12l28.75-16.68c.83-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-28.75,16.68c-.83.48-1.51.26-1.51-.49A3,3,0,0,1,261.48,184.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,203.66a5.47,5.47,0,0,0,2.49,4.3h0a5.62,5.62,0,0,0,4.55.21c-1.17.44-2.06-.23-2.06-1.65V186.14a5.06,5.06,0,0,1,.73-2.45l-5-2.87a5.09,5.09,0,0,0-.73,2.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,159.34c-.29-1.05-1.25-1.39-2.4-.73l-40.26,23.22a5,5,0,0,0-1.75,1.86l-5-2.86a5,5,0,0,1,1.75-1.86l40.24-23.22a5.53,5.53,0,0,1,5,0h0A5.47,5.47,0,0,1,298.21,159.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.78,193l-3.14-1.8a3.35,3.35,0,0,0-3.36.34,9.55,9.55,0,0,0-3.19,3.25,9.94,9.94,0,0,0-1.59,5,3.36,3.36,0,0,0,1.39,3.09l3.16,1.81a3.3,3.3,0,0,0,3.46-.29,10.56,10.56,0,0,0,4.78-8.28A3.29,3.29,0,0,0,296.78,193Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.64,191.21a3.35,3.35,0,0,0-3.36.34,9.55,9.55,0,0,0-3.19,3.25,9.94,9.94,0,0,0-1.59,5,3.36,3.36,0,0,0,1.39,3.09l3.12,1.79a3.47,3.47,0,0,1-1.28-3,9.9,9.9,0,0,1,1.59-5,9.58,9.58,0,0,1,3.19-3.26,3.48,3.48,0,0,1,3.24-.41Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.24,195c.87-.51,1.59-.09,1.59.92a3.52,3.52,0,0,1-1.59,2.75c-.88.51-1.59.1-1.59-.92A3.51,3.51,0,0,1,293.24,195Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,203.72a8.3,8.3,0,0,0,2.93-3.18v-.12c0-1.67-1.17-2.34-2.61-1.51l-.9.52a5.81,5.81,0,0,0-2.6,4.28,2.5,2.5,0,0,0,.24.22h0l0,0A2.75,2.75,0,0,0,293.44,203.72Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,257.46l-2.89-1.67a.22.22,0,0,1-.13-.12l-.54-.93,1.72-1-.05.16Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.08,257.46l-2.89-1.67a.22.22,0,0,1-.13-.12l-.54-.93,1.72-1-.05.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279,253.9l2,3.46a.3.3,0,0,0,.54-.05l2.11-6.1Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.65,236.67a5.5,5.5,0,0,0-2.49-4.3h0a5.51,5.51,0,0,0-5,0l-14.25,8.22a5.49,5.49,0,0,0-2.48,4.3v5.44a5.49,5.49,0,0,0,2.48,4.31h0a5.45,5.45,0,0,0,5,0l14.48-8.38c2.24-1.27,2.26-2.55,2.26-4.13Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,250.33a5.49,5.49,0,0,0,2.48,4.31h0a5.54,5.54,0,0,0,4.55.21c-1.17.45-2.06-.22-2.06-1.64v-5.44a5.09,5.09,0,0,1,.73-2.45l-5-2.87a5.09,5.09,0,0,0-.73,2.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,236c-.29-1.06-1.25-1.39-2.4-.73l-14.25,8.22a4.89,4.89,0,0,0-1.75,1.85l-5-2.86a5.16,5.16,0,0,1,1.75-1.86l14.25-8.22a5.57,5.57,0,0,1,5,0h0A5.45,5.45,0,0,1,294.56,236Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,246.23a3,3,0,0,0-1.36,2.36c0,.86.6,1.22,1.36.78a3,3,0,0,0,1.36-2.35C282.29,246.15,281.68,245.8,280.93,246.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,243.74a3,3,0,0,0-1.36,2.36c0,.86.61,1.22,1.36.78a3,3,0,0,0,1.36-2.35C286.59,243.66,286,243.31,285.23,243.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.54,241.25a3,3,0,0,0-1.36,2.35c0,.87.61,1.22,1.36.79A3,3,0,0,0,290.9,242C290.9,241.17,290.29,240.82,289.54,241.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.78,250.73l-3.14-1.8a3.35,3.35,0,0,0-3.36.34,9.55,9.55,0,0,0-3.19,3.25,9.94,9.94,0,0,0-1.59,5,3.36,3.36,0,0,0,1.39,3.09l3.16,1.81a3.3,3.3,0,0,0,3.46-.29,10.56,10.56,0,0,0,4.78-8.27A3.3,3.3,0,0,0,296.78,250.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.64,248.93a3.35,3.35,0,0,0-3.36.34,9.55,9.55,0,0,0-3.19,3.25,9.94,9.94,0,0,0-1.59,5,3.36,3.36,0,0,0,1.39,3.09l3.12,1.79a3.47,3.47,0,0,1-1.28-3,9.9,9.9,0,0,1,1.59-5,9.67,9.67,0,0,1,3.19-3.26,3.48,3.48,0,0,1,3.24-.41Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.24,252.73c.87-.5,1.59-.09,1.59.92a3.52,3.52,0,0,1-1.59,2.75c-.88.51-1.59.1-1.59-.92A3.51,3.51,0,0,1,293.24,252.73Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,261.44a8.3,8.3,0,0,0,2.93-3.18v-.12c0-1.67-1.17-2.34-2.61-1.51l-.9.52a5.81,5.81,0,0,0-2.6,4.28,2.5,2.5,0,0,0,.24.22h0A2.75,2.75,0,0,0,293.44,261.44Z",
    style: {
      fill: "#1500AC"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.59,214.1l-5.14-3a.56.56,0,0,1-.24-.22l-.94-1.65,3.05-1.76-.1.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.85,207.76l3.56,6.16a.53.53,0,0,0,1-.09L388.13,203Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,163.14a5.52,5.52,0,0,0-2.49-4.31h0a5.45,5.45,0,0,0-5,0l-40.25,23.21a5.52,5.52,0,0,0-2.49,4.31v20.38a5.5,5.5,0,0,0,2.49,4.31h0a5.51,5.51,0,0,0,5,0l40.48-23.39c2.23-1.27,2.26-2.55,2.26-4.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84,206.74a5.5,5.5,0,0,0,2.49,4.31h0a5.56,5.56,0,0,0,4.54.2c-1.17.45-2.06-.22-2.06-1.64V189.23a5.06,5.06,0,0,1,.73-2.45l-5-2.87a5.09,5.09,0,0,0-.73,2.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,162.43c-.29-1.05-1.25-1.39-2.4-.73L374.3,184.92a4.92,4.92,0,0,0-1.75,1.86l-5-2.86a5,5,0,0,1,1.75-1.86l40.24-23.22a5.53,5.53,0,0,1,5,0h0A5.47,5.47,0,0,1,417,162.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.49,194.09l28.75-16.68c.84-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-28.75,16.68c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,378.49,194.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.49,200l20-11.62c.83-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-20,11.62c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,378.49,200Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.49,188.21l28.75-16.68c.84-.48,1.51-.26,1.51.49a3,3,0,0,1-1.51,2.23l-28.75,16.68c-.83.48-1.5.26-1.5-.49A3,3,0,0,1,378.49,188.21Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.67,135.85l5.14-3a.51.51,0,0,0,.24-.22l1-1.65-3.06-1.76.1.27Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.67,135.85l5.14-3a.51.51,0,0,0,.24-.22l1-1.65-3.06-1.76.1.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,129.5l-3.56,6.16a.53.53,0,0,1-1-.09l-3.76-10.85Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,95.16a5.47,5.47,0,0,1,2.49-4.3h0a5.51,5.51,0,0,1,5,0l40.26,23.22a5.49,5.49,0,0,1,2.48,4.3v20.39a5.49,5.49,0,0,1-2.48,4.3h0a5.51,5.51,0,0,1-5,0L88.18,119.68c-2.23-1.27-2.25-2.55-2.25-4.13Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,125.11,94,108.43c-.83-.48-1.5-.26-1.5.49a3,3,0,0,0,1.5,2.23l28.75,16.68c.84.48,1.51.26,1.51-.49A3,3,0,0,0,122.74,125.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,125.88,94,114.26c-.83-.48-1.5-.26-1.5.49A3,3,0,0,0,94,117l20,11.62c.83.48,1.51.26,1.51-.49A3,3,0,0,0,114,125.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,119.23,94,102.55c-.83-.48-1.5-.26-1.5.49a3,3,0,0,0,1.5,2.23L122.74,122c.84.48,1.51.26,1.51-.49A3,3,0,0,0,122.74,119.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.12,138.77a5.49,5.49,0,0,1-2.48,4.3h0a5.54,5.54,0,0,1-4.55.21c1.17.44,2.06-.23,2.06-1.64V121.25a5.09,5.09,0,0,0-.73-2.45l5-2.86a5,5,0,0,1,.73,2.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,94.46c.29-1.06,1.25-1.39,2.4-.73L128.67,117a4.89,4.89,0,0,1,1.75,1.85l5-2.86a5.16,5.16,0,0,0-1.75-1.86L93.39,90.86a5.53,5.53,0,0,0-5,0h0A5.47,5.47,0,0,0,86,94.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.76,147.19l-5.54-3.2a.53.53,0,0,1-.26-.23l-1-1.78,3.29-1.9-.1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.73,140.35l3.83,6.64a.58.58,0,0,0,1-.1l4-11.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.21,61.32a5.91,5.91,0,0,0-2.68-4.64l-2.18-1.26a5.89,5.89,0,0,0-5.36,0L319.48,85.17a5.91,5.91,0,0,0-2.68,4.64v49.68a5.91,5.91,0,0,0,2.68,4.64l2.18,1.26a5.89,5.89,0,0,0,5.36,0l51.76-29.93c2.41-1.37,2.43-2.75,2.43-4.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,139.49a5.91,5.91,0,0,0,2.68,4.64l2.18,1.26a6,6,0,0,0,4.9.23c-1.26.47-2.22-.25-2.22-1.77V94.16a5.44,5.44,0,0,1,.79-2.64l-7.54-4.35a5.41,5.41,0,0,0-.79,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.12,60.56c-.31-1.14-1.35-1.5-2.59-.79L327,89.52a5.37,5.37,0,0,0-1.89,2l-7.54-4.35a5.45,5.45,0,0,1,1.89-2L371,55.42a6,6,0,0,1,5.36,0l2.19,1.26A5.92,5.92,0,0,1,381.12,60.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,97.49a1.85,1.85,0,0,1,.84-1.44L373,71.48a1.89,1.89,0,0,1,1.67,0l.94.54a1.87,1.87,0,0,1,.83,1.44v32.62a1.89,1.89,0,0,1-.83,1.45L333.09,132.1a1.89,1.89,0,0,1-1.67,0l-.93-.54a1.87,1.87,0,0,1-.84-1.45Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,97.49a1.85,1.85,0,0,1,.84-1.44L373,71.48a1.89,1.89,0,0,1,1.67,0l.94.54a1.87,1.87,0,0,1,.83,1.44v32.62a1.89,1.89,0,0,1-.83,1.45L333.09,132.1a1.89,1.89,0,0,1-1.67,0l-.93-.54a1.87,1.87,0,0,1-.84-1.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,98.79l-3.65-2.12a1.73,1.73,0,0,0-.25.82v32.62a1.87,1.87,0,0,0,.84,1.45l.93.54a1.89,1.89,0,0,0,1.67,0l.46-.27Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,98.79l-3.65-2.12a1.73,1.73,0,0,0-.25.82v32.62a1.87,1.87,0,0,0,.84,1.45l.93.54a1.89,1.89,0,0,0,1.67,0l.46-.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.48,73.46v32.63a1.86,1.86,0,0,1-.75,1.38l0,0-.05,0L333.09,132.1h0a.6.6,0,0,1-.57.06.57.57,0,0,1-.25-.55V99a.71.71,0,0,1,.93-.73l17.9,4.25,2.34.56a1.56,1.56,0,0,0,1.5-.56l2.71-3.78,18.28-25.45C376.23,72.85,376.48,72.93,376.48,73.46Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,107.53l.05,0,0,0a1.71,1.71,0,0,0,.49-.54,1.75,1.75,0,0,0,.26-.83l-18.84-7.37,12.61,11.91Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,107.53l.05,0,0,0a1.71,1.71,0,0,0,.49-.54,1.75,1.75,0,0,0,.26-.83l-18.84-7.37,12.61,11.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26,131.61a.57.57,0,0,0,.25.55.6.6,0,0,0,.57-.06h0l14.65-8.46,3.35-21.13-18.83,28.56Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26,131.61a.57.57,0,0,0,.25.55.6.6,0,0,0,.57-.06h0l14.65-8.46,3.35-21.13-18.83,28.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,106.93a1.71,1.71,0,0,1-.49.54l0,0L333.09,132.1h0a.6.6,0,0,1-.57.06l20.38-32.53a3.21,3.21,0,0,1,4-1.23Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,98.21,352,106.76a3.16,3.16,0,0,0,4-1.22L376.26,73Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,98.21l19.5,7.29a3.17,3.17,0,0,0,3.76-1.24L376.26,73Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,49,388,46.35h0l0,0h0c-1.54-.87-3.66-.74-6,.61-4.71,2.72-8.53,9.34-8.53,14.79,0,2.71.95,4.62,2.49,5.52h0l4.19,2.4.75-1.26a8.75,8.75,0,0,0,2.45-1c4.72-2.73,8.54-9.35,8.54-14.79a9.09,9.09,0,0,0-.27-2.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.24,49.44c-4.71,2.72-8.53,9.34-8.53,14.78s3.82,7.66,8.53,4.93,8.54-9.34,8.54-14.78S391,46.72,386.24,49.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.19,59.53a.38.38,0,0,1-.06-.28.93.93,0,0,1,.13-.35l2.48-4,.23-.34a1,1,0,0,1,.31-.3l1.4-.82a.21.21,0,0,1,.23,0,.3.3,0,0,1,.09.24v10a.75.75,0,0,1-.09.34.63.63,0,0,1-.23.25l-1.51.88a.18.18,0,0,1-.22,0,.3.3,0,0,1-.09-.24V58.15l-1.38,2.19a.46.46,0,0,1-.23.21.17.17,0,0,1-.21,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.36,310.19c-2.43-2.82-4.39-6.82-5.26-7.65C395.57,300.13,393,266,393,266c5.91-.2,9.08,2,10.1,6.54s5.07,26.5,5.07,26.5",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,312.73c-2.94,5.94-10.2,23.82-13.08,36.19-2.7,11.58-3.75,19.6,0,22.4s14.48,1.1,21.28-13.37c2.13-4.53,10.14-18.51,10.14-18.51s5.92-2.13,8-3.73c0,0,19.76.57,29.36-1.39s19.81-13.7,15.88-14.85c-7.07-2.08-20.85-3.59-36.8-4.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.59,331.84c-4.32,1-10.72-.34-14.34-1.39a9.45,9.45,0,0,0-.12-3.83,12.5,12.5,0,0,1-1.6,4.8c-.59.34-1.1.62-1.46.8-2.4,1.23-9,4.6-10.22,3.54a12.9,12.9,0,0,0-7.4-4.69c2.07,1.39,8.06,5.68,5.93,10.66l1.31-2.29s5.92-2.13,8-3.73c0,0,11,.32,20.64-.34l11.38-7.88S420.22,327.17,413.59,331.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,345.67c-2.07,1.87-5.23,3.37-7.45,2.91s-5.4-.68-6.64,3.75c-1.41,5-6,8.09-8.52,10.85s-1.73,6.9-.41,9.76c2.22,4.82,5.46,1.91,7.26-1.15s7.08-8.67,9.63-11a91.85,91.85,0,0,1,9-7.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.28,319.1c12.37-1.26,12.62,6.29,9.44,11.4-3.43,5.5-16.52,12.29-22.93,15.55s-15.36,8.38-15.36,8.38A13,13,0,0,1,400,347c7-4.92,13.89-17.56,25.64-19.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,348.66h0a5.43,5.43,0,0,1-.82-.08c-2.22-.47-5.4-.68-6.64,3.75-1.41,5-6,8.09-8.52,10.85s-1.73,6.9-.41,9.76c2.22,4.82,5.46,1.91,7.26-1.15a35,35,0,0,1,3.29-4.36,3.4,3.4,0,0,1-4.62.55c-.91-.79-.24-3.57,1.45-5.44S394.72,348.51,395.89,348.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,347.2c2.26-.57,5.58-1.38,6.95-3.18s4.21-3.55,8.06-1c4.36,2.87,9.82,2.19,13.54,2.6s5.83,4.08,6.71,7.1c1.49,5.1-2.79,3.36-6.15,2.23s-11.17-2.19-14.48-1.75-11.61,2.54-11.61,2.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.94,354.46c.59.15,1.14.3,1.6.46,3.36,1.13,7.64,2.87,6.15-2.23-.88-3-3-6.68-6.71-7.1s-9.18.27-13.54-2.6c-3.85-2.52-6.69-.78-8.06,1a4.64,4.64,0,0,1-.53.56h0s4.43,1.37,9.31,2.78,13.14,3.85,13.45,5.11C426.84,353.38,427,354.52,424.94,354.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.24,368c.72,4.4,5.65,6.52,16.22,4.4s33.34-16.57,33.34-16.57,1.4-7.45-4.38-9.08c0,0-5.26,1-13.84,2.82a112.3,112.3,0,0,0-11.46,3.17c-5.8,7.78-11.84,4.64-14,7.38C354.49,364.71,352.24,368,352.24,368Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.43,350.58a39,39,0,0,0-12.37,4.94s5.41-6.34,13.77-7.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.51,293.76c.48,4.5,1.59,21.09,1.59,21.09-3.49,11.77-30.59,9.4-35.83.17a77.39,77.39,0,0,0,4.07-11.85l-2.88-12.59s6.89-6.28,0-19.1l9.11-2.73L393,266c2.77.15,7.47,6.5,9.28,11.14C403.43,280.11,404.36,286.14,400.51,293.76Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.3,322.83c-11.37-.48-16.61-7.47-16.49-9.31a74,74,0,0,1,1.68-8l4.26,1.67-3.51-5.12-2.43-10.91c2.57-3.77,1.3-10.59,1.3-10.59l-.71-.42c.83,7-2.94,10.43-2.94,10.43l2.88,12.59A77.39,77.39,0,0,1,366.27,315C369.05,319.92,378,322.89,386.3,322.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.17,261.63l-6,.16a15.07,15.07,0,0,1-15.48-14.66h0a18.06,18.06,0,0,1,17.56-18.55h0a18.06,18.06,0,0,1,18.55,17.56h0A15.08,15.08,0,0,1,386.17,261.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,238.35l-4.49-1.57a2.3,2.3,0,0,1,3-1.53A2.5,2.5,0,0,1,367.66,238.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.61,237.19l-1.38-4.54a2.29,2.29,0,0,1,3,1.49A2.48,2.48,0,0,1,367.61,237.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,236.36c1.94,1.08,4.43,5.81,4.47,15.88,0,8.53-2.67,10.71-4,11.35s-4.06.35-6.67,0l.05,3.53s4.69,5.13,4.52,7.48-6,3.57-9.42,1.37a27.45,27.45,0,0,1-6.39-6.53l-.26-11.82s-1.49,1.53-4.15-.67c-2.19-1.82-3-5-1.37-6.7a3.73,3.73,0,0,1,6,1s4.15,0,9.59-3.15A15.52,15.52,0,0,0,393.63,236.36Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.52,250.35a1.07,1.07,0,1,1-2.13.16,1.07,1.07,0,1,1,2.13-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,257.57l2.51.73a1.28,1.28,0,0,1-1.6.93A1.36,1.36,0,0,1,389,257.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,246.82,395,245.38a1.28,1.28,0,0,1,1.8-.42A1.38,1.38,0,0,1,397.22,246.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.79,249.35a1.08,1.08,0,0,1-1,1.19,1.09,1.09,0,0,1-1.16-1,1.07,1.07,0,1,1,2.14-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.94 248.34 392.06 255.32 395.43 254.18 391.94 248.34",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.39,263.58c-2.75-.29-8.44-1.76-9.38-4a5.85,5.85,0,0,0,2.06,2.79c1.72,1.4,7.37,2.87,7.37,2.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.32,343.42v.81a2.28,2.28,0,0,0,1.13,2l21.68,12.47a2.25,2.25,0,0,0,2.28,0l39.77-23a2.26,2.26,0,0,0,1.14-2v-.55l-42.05,24.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.32,333.19l-23.58-13.62a1.37,1.37,0,0,0-1.36,0L369.47,343.2a.3.3,0,0,0,0,.52l23.8,13.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.15,299c3.17,4.61,10.36,14.63,13.59,20.37,1.86,3.31-.48,6.52-5.56,5.16-3.35-.89-8.16-8.92-12.82-14.36",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.06 355.46 380.34 348.13 417.53 326.65 430.32 333.95 393.06 355.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.8 335.05 387.04 335.19 393.27 338.79 404.36 332.39 404.59 332.26 398.12 328.52 386.8 335.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.04 335.19 393.27 338.79 404.36 332.39 398.12 328.79 387.04 335.19",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.27,357.46V359a2.22,2.22,0,0,0,1.14-.31l39.77-23a2.26,2.26,0,0,0,1.14-2v-.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.27,357.46V359a2.22,2.22,0,0,0,1.14-.31l39.77-23a2.26,2.26,0,0,0,1.14-2v-.55Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.91,357.8a2.7,2.7,0,0,0,2.32-.18l39.6-22.86a2.66,2.66,0,0,0,1.31-1.89L441.48,307a3.25,3.25,0,0,0,0-.44,2.71,2.71,0,0,0-.79-1.92l-41.15,23.77a2,2,0,0,0-1,1.39Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.91,357.8a2.7,2.7,0,0,0,2.32-.18l39.6-22.86a2.66,2.66,0,0,0,1.31-1.89L441.48,307a3.25,3.25,0,0,0,0-.44,2.71,2.71,0,0,0-.79-1.92l-41.15,23.77a2,2,0,0,0-1,1.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.27,357.47l.27.15a3.14,3.14,0,0,0,.37.18l4.69-28a2,2,0,0,1,1-1.39l41.15-23.77a3.28,3.28,0,0,0-.55-.41l-41.24,23.8a2,2,0,0,0-1,1.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.22,333.93a8.7,8.7,0,0,1,4-5.13c1.91-1.11,3.23-.6,2.94,1.13a8.79,8.79,0,0,1-4,5.14C417.24,336.17,415.93,335.66,416.22,333.93Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,338.74c-2.18-1.5-16.07-11.61-21.62-15.91-5.78-4.48-5.43-5.92-4.73-9.15,1.38-6.38,10.14-26.47,12.55-32.43,2.7-6.65,3.32-7.49,8.56-9.77,3.62,2.86,5.64,9.87.77,19.53l-9.92,23.34s6.61,7,10.52,10.7,7.36,7.85,10.28,8.17c2.32.25,6.43.41,7.31,1.22a68.64,68.64,0,0,1,6,6.92c.83,1.36,2.8,4.13,0,5-2.55.8-4.63-.29-6.71-1.71a27.63,27.63,0,0,1-2.77-2.29,10.12,10.12,0,0,1-6-1.19C375.34,340.29,372.7,338.74,372.7,338.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.34,280.57h.29a10.56,10.56,0,0,0,10.55-10.82l-.27-11.25h0a10.56,10.56,0,0,0-10.57,10.56Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.63,243.21c-1,2.15-4.22,5.27-7.95,1.25-5.45-5.89-14.43-26.8-14.43-26.8l5.9-2.73,12,16.42,6.41,7.12",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.22,203.06c-2.83,9.49-8.52,30.63-8.52,30.63l6.93,9.52a55.6,55.6,0,0,0,3.16-7.56C89,232.35,93,219.18,93,219.18s-.85-19,2.12-21.54a17.3,17.3,0,0,1,5.46-3.27C95.85,194.75,88.8,194.37,86.22,203.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,204.43c-1.57-2.92-2-3.05-2.89-3.69s-6.65-1.49-9-1.69c-2.8-.24-3.79.28-3,2.68,1.66,5.14,6.7,16.05,7.83,17.56.74,1,.89,1.9,4,2.21,2.93.28,6.61.44,7.69.51s2.58.33,1.61-2.85a106.82,106.82,0,0,0-4.28-10.59C73.67,206,72.92,204.43,72.92,204.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25,217.66c-1.17-5.16-4.6-9.92-2.66-11.66l1,2.28s6.42,1.54,9.52,1.3,5.63-1,6.48-.38c1.8,1.27,2.32,6.67-2.84,8.64C69.41,219.5,62.25,217.66,62.25,217.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,192.68c-5.68.06-11.93,2.13-14.08,6.58S80.79,220,80.79,220a16,16,0,0,0,12.3,4.12Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,192.68c-5.68.06-11.93,2.13-14.08,6.58S80.79,220,80.79,220a16,16,0,0,0,12.3,4.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.82,
    y: 356.68,
    width: 7.86,
    height: 11.44,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.39,
    y: 342.65,
    width: 7.86,
    height: 11.44,
    transform: "translate(-11.92 3.45) rotate(-1.97)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16,245c0,7.51,1,56,1,56,.18,2.15,2.2,6.13,1.77,14.42-.6,11.27-1.57,42.55-1.57,42.55s-3.69,3.66-8.89,0c0,0-7.11-42.51-8.52-53.67-1.23-9.74-3.31-36.2-3.31-36.2l-4,31.76s1.28,7.33,1.56,12.49-4.61,34.41-4.61,34.41a8.57,8.57,0,0,1-8.55.32s-3-43-3.84-47.66S88.41,245,88.41,245Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,193c.92.22,8.49,2,11.83,3.13V245c-5.51,6-24.72,8.79-36.75,0V206.7c0-6.12,3.4-13.47,12.79-14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,161.72a4.19,4.19,0,0,1,3.46,1.22c1.49,1.52,1.18,4.34,0,10.81l-4.6.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.17,159.85a7.28,7.28,0,0,1-2.88-.58c-1.41-.81-1.78.79-1,2.18A6.55,6.55,0,0,0,90.62,165c0-.2,1.32-3.6,1.32-3.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,174.28c.68.41,1.66-.9,2.5-1.78s3.59-2.09,5,.8-1.21,6.83-3.38,7.51c-3.72,1.17-4.28-1.22-4.28-1.22L113.33,193a12,12,0,0,1-9,6.87c-6.61.9-5.25-4.56-3.08-7.23v-4.09a23.77,23.77,0,0,1-5,.26c-2.75-.42-4.47-2.59-5.3-5.56-1.34-4.76-1.85-8.61-.71-18,1.24-10.28,13.19-10.38,19.65-6.32S113.82,174.28,113.82,174.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,175.43c.34,0,1.65-2.16,2.5-2.93,1.18-1.08-.34-10.78-.34-10.78s1.19-3.68-1.14-6.12-6.84-2-10.13-2.14a29.84,29.84,0,0,1-11.79-2.37c-4.68-2-5-2.27-5.61-.22s-.8,6.77,2,9.92l2.33.86s1.25,1.11,5.62,1.64a64.68,64.68,0,0,0,12.1-.22c1.27-.18,1.54,1.05,2.22,4.4C112.17,170.42,112.67,175.41,113.82,175.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,162.48l4.13-2.22a2.28,2.28,0,0,0-3.13-1A2.45,2.45,0,0,0,116,162.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,188.59s6.12-1.23,8.26-2.37a7.07,7.07,0,0,0,3-2.93,9.66,9.66,0,0,1-1.68,3.46c-1.56,2-9.54,3.47-9.54,3.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68,172.75a1.23,1.23,0,1,0,1.23-1.28A1.25,1.25,0,0,0,102.68,172.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,168.12l2.63,1.45a1.58,1.58,0,0,0-.61-2.09A1.46,1.46,0,0,0,104,168.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.77,181.22,99,182.27a1.46,1.46,0,0,0,1.9.93A1.57,1.57,0,0,0,101.77,181.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,169.14l2.4-1.84a1.45,1.45,0,0,0-2.08-.32A1.59,1.59,0,0,0,91.74,169.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,172.4a1.23,1.23,0,1,0,1.23-1.28A1.25,1.25,0,0,0,92.48,172.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.73 171.24 98.33 178.61 94.48 177.3 98.73 171.24",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.82,364.24v-1.12c-.75.32-2.5,7-5.62,9.83-2.48,2.26-5.86,4.87-6.72,7.39s4.71,4.07,7,3.66c2.69-.48,7.35-2.37,8.52-4.13s1.72-4.34,2.67-5.63,3.14-2.72,3.66-4.21c.28-.82-.06-2.61-.45-4.13s-.76-2.91-1.24-2.78V364a6.21,6.21,0,0,1-3.92,1.33C120.6,365.34,117.81,365.12,117.82,364.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,351.8c-.41,0-.74.59-1.64,1.56a17.1,17.1,0,0,1-4.62,3.33c-2.94,1.47-8.66,3.74-11.25,4.9-1.62.73-1.54,2.68.13,3.79s5.71,1.92,10.55.83c2.64-.59,6.08-3,8.25-2.89s6.25.1,7.85-1,1-3.47.51-5.5c-.49-2.22-1.2-5.61-1.93-5.46l0,.7c-.94,1.43-5.75,2-7.83,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6,239.5c.49-2.36-4.8-25.79-6.87-33.2L123.56,217l5.64,23.12a130.13,130.13,0,0,1-4.6,19.08,4.2,4.2,0,0,1-2,2.24c-2.45,1.31-3.49,2.75-5.38,4.48-1.48,1.35-2.68,1.63-2.53,2.11a2.28,2.28,0,0,0,2.84,1.23A16.53,16.53,0,0,0,121,267.7a21.35,21.35,0,0,1-3.8,5.62c-3.56,3.8-3.87,6.27,2.76,6.77,4.15.32,7.64-2,11.39-11,1.08-2.57,2.44-6.32,3.46-9.71C137.21,251.39,138.47,245,139.6,239.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44,210.28c-2.5-5.74-1.25-12.46,1.52-15.07,7,1.21,8.83,4.54,10.77,11.09,3,10.1,4.49,16.66,4.49,16.66-1.76,2.34-8.77,5.06-12.06,4.06Z",
    style: {
      fill: "#1500AC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44,210.28c-2.5-5.74-1.25-12.46,1.52-15.07,7,1.21,8.83,4.54,10.77,11.09,3,10.1,4.49,16.66,4.49,16.66-1.76,2.34-8.77,5.06-12.06,4.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.16 227.02 121.96 215.67 125.16 237.02 125.16 227.02",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,268.13a29.13,29.13,0,0,1-10.94-6.27s2.11,3.95,8.39,7.63l-.34,21.6Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesAmico);
export default __webpack_public_path__ + "static/media/Messages-amico.dd57d8968348248b70d52a4193e27d15.svg";
export { ForwardRef as ReactComponent };